<template>
	<el-dialog title="内容" :close-on-click-modal="false" :visible.sync="visible"
		width="950px" :append-to-body="true">
		<el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="95px" class="border-form">
			<el-row class="form-title">
				文字描述
			</el-row>
			<el-row class="set_border">
				<el-col :span="24">
					<el-input type="textarea" :rows="10" v-model="dataForm.itemContext" class="set_data no-border-input">
					</el-input>
				</el-col>
			</el-row>
			<el-row class="form-title" style="margin-top: 5px;">
				照片
			</el-row>
			<el-row>
				<el-col :span="6">
					<el-upload ref="uploadPhoto" class="upload-demo" action="action" :before-upload="beforeUploadSituation"
						style="margin-left: -20px;margin-top: 5px;" :http-request="uploadPhoto" multiple drag
						:show-file-list=false :auto-upload="true" accept="image/jpeg,image/png,image/jpg">
						<i class="el-icon-upload"></i>
						<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
					</el-upload>
				</el-col>
				<el-col :span="18">
					<el-table v-if="dataForm.photoList != undefined && dataForm.photoList.length > 0" border
						:data="dataForm.photoList" style="width: 100%;margin-top: 5px;">
						<el-table-column type="index" label="序号" width="60" align="center">
						</el-table-column>
						<el-table-column label="图片" width="130" align="center">
							<template slot-scope="scope">
								<el-image style="height: 100px" :src="scope.row.compressedPathUri"
									fit='contain'></el-image>
							</template>
						</el-table-column>
						<el-table-column label="描述" min-width="400px" align="center">
							<template slot-scope="scope">
								<el-input type="textarea" rows="2"
									v-model="dataForm.photoList[scope.$index].photoContext"
									placeholder="请填写"></el-input>
							</template>
						</el-table-column>
						<el-table-column label=" " width="60">
							<template slot-scope="scope">
								<el-button type="text" size="mini" @click="delPhoto(scope.$index)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-col>
			</el-row>
		</el-form>
		<el-row class="formBtnGroup" style="margin-top: 5px;">
			<el-button v-preventReClick class="btn" type="primary" size="small" @click="dataFormSubmit()">保存</el-button>
			<el-button v-preventReClick class="rebtn" size="small" @click="visible = false">取消</el-button>
		</el-row>
	</el-dialog>
</template>

<script>
import $common from "@/utils/common.js"
export default {
	name: "hqcontact-content-photo",
	data() {
		return {
			visible: false,
			inline: false,
			action: '',
			dataForm: {
				workNo: $common.getItem("workNo"),
				photoId: '',
				fileId: '',
				itemContext: '',
				photoList: []
			},
			dataRule: {
			},
		}
	},
	components: {
	},
	methods: {
		init(fileId, content) {
			this.dataForm = {
				workNo: $common.getItem("workNo"),
				photoId: '',
				fileId: '',
				itemContext: '',
				photoList: []
			}
			if (content != null) {
				this.dataForm.photoId = content.photoId
				this.dataForm.itemContext = content.itemContext
				this.dataForm.photoList = content.photoList
			}
			this.dataForm.fileId = fileId
			this.$nextTick(() => {
				this.visible = true;
			})
		},
		uploadPhoto(param) {
			const formData = new FormData();
			formData.append('file', param.file);
			this.$refs.uploadPhoto.clearFiles();
			this.$http.post(
				this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/20/01",
				formData,
				{
					headers: { 'Content-Type': 'multipart/form-data' }
				},
			).then(res => {
				res = res.data
				if (res.resultCode === 200) {
					// 获取序号
					let showSort = 1;
					if (this.dataForm.photoList != undefined && this.dataForm.photoList.length > 0) {
						for (var i = 0; i < this.dataForm.photoList.length; i++) {
							if (showSort < this.dataForm.photoList[i].showSort) {
								showSort = this.dataForm.photoList[i].showSort
							}
						}
					}
					this.dataForm.photoList.push({
						showSort: showSort,
						photoName: res.body.fileName,
						photoUri: res.body.fileUri,
						photoPath: res.body.fileSavePath,
						compressedPath: res.body.compressedPath,
						compressedPathUri: res.body.fileUri,
						photoContext: this.extractFileName(res.body.fileName)
					});
				} else {
					this.$message.info('文件上传失败')
				}
			})
		},
		extractFileName(fileName) {
			let index = fileName.lastIndexOf(".");
			return fileName.substr(0, index)
		},
		delPhoto(index) {
			this.dataForm.photoList.splice(index, 1)
		},
		//表单提交
		dataFormSubmit() {
			this.visible = false
			this.$emit('problemPhotoItems', this.dataForm)
		},
		beforeUploadSituation(file) {
			const isValidType = file.type === 'image/jpeg' ||
				file.type === 'image/png' ||
				file.type === 'image/jpg'

			if (!isValidType) {
				this.$message.error('只能上传 JPG/PNG 格式的图片！')
				return false
			}
			return true
		},
	}
}
</script>
<style scoped lang="scss">
.form-title {
	background-color: #E1F1FF;
	color: #00428E;
	font-weight: bold !important;
	padding: 10px;
	border: solid #dadada 1px;
}

.no-border-input.el-date-editor.el-date-editor--date {
	::v-deep .el-input__suffix {
		display: flex !important;
		align-items: center !important;
		justify-content: center !important;
		position: absolute !important;
		/* 必须加！否则right无效且图标易消失 */
		top: 50% !important;
		/* 垂直居中，避免图标偏移 */
		transform: translateY(-50%) !important;
		right: 5px !important;
		/* 你要的右侧5px间距 */
		width: auto !important;
		/* 取消固定宽度，避免容器遮挡 */
		height: 100% !important;
		/* 占满高度，确保点击生效 */
		pointer-events: auto !important;
		/* 保证图标可点击，避免失效 */
		z-index: 1 !important;
		/* 防止图标被遮挡 */
	}

	/* 隐藏左侧占位，不影响右侧图标 */
	::v-deep .el-input__prefix {
		display: none !important;
		width: 0 !important;
		padding: 0 !important;
		margin: 0 !important;
	}

	/* 补充：给输入框右侧留空间，避免文字遮挡图标 */
	::v-deep .el-input__inner {
		padding-right: 30px !important;
		/* 适配5px右侧间距，留出图标空间 */
		padding-left: 15px !important;
		/* 重置左侧内边距，消除空白 */
		border-radius: 0 !important;
		// border: 1px solid #dadada !important;
	}
}

.no-border-input ::v-deep .el-textarea__inner {
	border: none !important;
}

.border-form .el-row.set_border {
	border-bottom: solid #dadada 1px;
	border-left: solid #dadada 1px;
	border-right: solid #dadada 1px;
}

.upload-demo ::v-deep .el-upload-dragger {
	width: 200px;
	height: 100px;
	margin-left: 20px;
}

.upload-demo ::v-deep .el-upload-dragger .el-icon-upload {
	font-size: 40px;
	margin-top: 15px;
	line-height: 26px;
}

.upload-demo ::v-deep .el-upload-dragger .el-upload__text {
	line-height: 8px;
}
</style>
